import _Tooltip from "@material-ui/core/esm/Tooltip";
import React from 'react';
import { Button, ButtonTextTransform } from 'swag-client-common/components/ui/button';
import classes from './before-approving-mockup.scss';
const tooltipText = "Mockup approval isn't available until mockup hasn't been uploaded.";
const BeforeApprovingMockupComponent = ({
  isMockupAvailable,
  onSkip,
  content
}) => {
  const {
    header,
    subHeader,
    rules,
    description
  } = content;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.beforeApprovingWrapper
  }, /*#__PURE__*/React.createElement("h2", {
    className: classes.title
  }, header), /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, subHeader), /*#__PURE__*/React.createElement("ul", {
    className: classes.rules
  }, rules.map((rule, idx) => /*#__PURE__*/React.createElement("li", {
    key: idx
  }, idx + 1, ". ", rule))), /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, description), /*#__PURE__*/React.createElement(Button, {
    dataButton: "Continue",
    type: "primary",
    onClick: onSkip,
    textTransform: ButtonTextTransform.none,
    disabled: !isMockupAvailable
  }, /*#__PURE__*/React.createElement(_Tooltip, {
    disableHoverListener: isMockupAvailable,
    title: tooltipText
  }, /*#__PURE__*/React.createElement("span", null, "Continue to Mockup Approval"))));
};
export { BeforeApprovingMockupComponent };